import { LocationQueryRaw, RouteLocationRaw } from 'vue-router';

import { AppRouteNames } from './app-routes.enum';

export const signInRoute = (): RouteLocationRaw => {
  return { name: AppRouteNames.SIGN_IN };
};

export const signUpRoute = (): RouteLocationRaw => {
  return { name: AppRouteNames.SIGN_UP };
};

export const companyOnboardingRoute = (queryParams?: LocationQueryRaw): RouteLocationRaw => {
  return {
    name: AppRouteNames.INVESTOR_COMPANY_ONBOARDING,
    query: queryParams || {},
  };
};

export const emailConfirmationRoute = (queryParams?: LocationQueryRaw): RouteLocationRaw => {
  return {
    name: AppRouteNames.SIGN_UP_CONFIRM_EMAIL,
    query: queryParams || {},
  };
};

export const missingPasswordSignInRoute = (queryParams: { email: string }): RouteLocationRaw => {
  return {
    name: AppRouteNames.MISSING_PASSWORD_SIGN_IN,
    query: queryParams || {},
  };
};

export const resetPasswordRoute = (queryParams: { email: string; sent: string }): RouteLocationRaw => {
  return {
    name: AppRouteNames.RESET_PASSWORD,
    query: queryParams || {},
  };
};

export const confirmResetPasswordRoute = (): RouteLocationRaw => {
  return { name: AppRouteNames.RESET_PASSWORD_CONFIRM };
};

export const oneTimeCodeSignInRoute = (queryParams: { email: string }): RouteLocationRaw => {
  return {
    name: AppRouteNames.ONE_TIME_CODE_SIGN_IN,
    query: queryParams || {},
  };
};

export const showingsRoute = (): RouteLocationRaw => {
  return { name: AppRouteNames.INVESTOR_SHOWINGS };
};

export const showingDetailsRoute = (showingId: string): RouteLocationRaw => {
  return {
    name: AppRouteNames.INVESTOR_PROPERTY_SHOWING_DETAILS,
    params: { showingId },
  };
};

export const portfolioRoute = (): RouteLocationRaw => {
  return { name: AppRouteNames.INVESTOR_PORTFOLIO };
};

export const propertyRoute = (propertyId: string): RouteLocationRaw => {
  return {
    name: AppRouteNames.INVESTOR_PROPERTY,
    params: { propertyId },
  };
};

export const propertyDashboardRoute = (propertyId: string): RouteLocationRaw => {
  return {
    name: AppRouteNames.INVESTOR_PROPERTY_DASHBOARD,
    params: { propertyId },
  };
};

export const propertyDetailsRoute = (propertyId: string): RouteLocationRaw => {
  return {
    name: AppRouteNames.INVESTOR_PROPERTY_DETAILS,
    params: { propertyId },
  };
};

export const renterProfileRoute = (propertyId: string, renterId: string): RouteLocationRaw => {
  return {
    name: AppRouteNames.INVESTOR_PROPERTY_RENTER_PROFILE,
    params: { renterId, propertyId },
  };
};

export const renterApplicationReviewRoute = (
  propertyId: string,
  renterId: string,
  applicationId: string,
): RouteLocationRaw => {
  return {
    name: AppRouteNames.INVESTOR_PROPERTY_RENTER_PROFILE_APPLICATION_REVIEW,
    params: { renterId, propertyId, applicationId },
  };
};

export const renterTransUnionReportRoute = (applicationId: string, reportType: string): RouteLocationRaw => {
  return {
    name: AppRouteNames.APPLICATION_REPORT,
    params: { applicationId, reportType },
  };
};
